import React from "react";
import Box from "./Box";
import { styles } from "../styles/theme";
import { formatMoney } from "../utils/helpers";

function PlayerStats({ playerData, gameData }) {
  return (
    <>
      <div style={styles.row}>
        <Box label="Jugador" value={playerData.name} />
        <Box label="Dinero" value={formatMoney(playerData.money || 0)} />
        <Box label="Panes ganados" value={playerData.breads || 0} />
        <Box
          label="Beca del Bienestar"
          value={
            gameData.baseStipend
              ? formatMoney(gameData.baseStipend * (gameData.stipendMultiplier || 1))
              : formatMoney(0)
          }
        />
      </div>
      <div style={styles.row}>
      </div>
    </>
  );
}

export default PlayerStats;
